export default __webpack_public_path__ + "static/media/phone-preview-header.d9a64a62.svg";